import { Button } from "../ui/Button/Button";
import MailIcon from "../../assets/EnvelopeSimple.svg";
import PhoneIcon from "../../assets/Phone.svg";
import LocationIcon from "../../assets/MapPin.svg";
import InstaIcon from "../../assets/Instagram.svg";
import LinkedInIcon from "../../assets/LinkedIn.svg";
import YoutubeIcon from "../../assets/Youtube.svg";

export const ContactUs = () => {
  return (
    <div className="w-full h-full flex flex-col justify-center items-center gap-y-8 md:gap-y-16">
      <div className="w-full flex gap-4">
        <div className="flex flex-col gap-2">
          <p className="text-sm md:text-base">For Inquiries: </p>
          <Button
            className="px-3 py-2 md:px-4 md:py-3"
            onClick={() => {
              window.location.href = "mailto:sales@tagglabs.in";
            }}
          >
            <img src={MailIcon} alt="mail" className="w-4 md:w-5 h-4 md:h-5" />
            <span className="text-sm md:text-base">sales@tagglabs.in</span>
          </Button>
        </div>
      </div>
      <div className="w-full flex gap-4">
        <div className="flex flex-col gap-2">
          <p className="text-sm md:text-base">Social: </p>
          <div className="flex gap-4">
            <Button className="px-3 py-2 md:px-4 md:py-3">
              <img
                src={InstaIcon}
                alt="Insta"
                className="w-4 md:w-5 h-4 md:h-5"
                onClick={() => {
                  window.open("https://www.instagram.com/tagglabs/", "_blank");
                }}
              />
            </Button>
            <Button className="px-3 py-2 md:px-4 md:py-3">
              <img
                src={LinkedInIcon}
                alt="LinkedIn"
                className="w-4 md:w-5 h-4 md:h-5"
                onClick={() => {
                  window.open(
                    "https://www.linkedin.com/company/tagglabs-technologies-pvt-ltd-/",
                    "_blank",
                  );
                }}
              />
            </Button>
            <Button className="px-3 py-2 md:px-4 md:py-3">
              <img
                src={YoutubeIcon}
                alt="Youtube"
                className="w-4 md:w-5 h-4 md:h-5"
                onClick={() => {
                  window.open(
                    "https://www.youtube.com/@Tagglabs?themeRefresh=1",
                    "_blank",
                  );
                }}
              />
            </Button>
          </div>
        </div>
      </div>
      <div className="w-full flex flex-col md:flex-row gap-6 md:gap-5">
        <div className="flex flex-col gap-2">
          <p className="text-sm md:text-base">Address: </p>
          <Button className="px-3 py-2 md:px-4 md:py-3">
            <img
              src={LocationIcon}
              alt="map"
              className="w-4 md:w-5 h-4 md:h-5"
            />
            <span className="text-sm md:text-base">
              {" "}
              Tagglabs Experiential Pvt. Ltd.{" "}
            </span>
          </Button>
        </div>
        <div className="flex flex-col gap-2 pb-8">
          <p className="text-sm md:text-base">Call Us: </p>
          <Button className="px-3 py-2 md:px-4 md:py-3">
            <img
              src={PhoneIcon}
              alt="phone"
              className="w-4 md:w-5 h-4 md:h-5"
            />
            <span className="text-sm md:text-base"> +91 98100 17599 </span>
          </Button>
        </div>
      </div>
    </div>
  );
};
